module.exports = __webpack_public_path__ + "static/media/l6.4b8db6fa.png";